if (!customElements.get('translation-notice-toast')) {
  class TranslationNoticeToast extends HTMLElement {
    static COOKIE_NAME = 'translation_notice_toast_dismissed';

    connectedCallback() {
      if (this.dataset.shouldShow !== 'true') return;
      if (this.isDismissedToday()) return;

      this.closeButton = this.querySelector('.translation-notice-toast__close');
      this.toast = this.querySelector('.translation-notice-toast');
      this.isClosing = false;

      this.closeButton?.addEventListener('click', this.dismiss.bind(this));
      this.show();
    }

    isDismissedToday() {
      return document.cookie.split('; ').some((cookie) => cookie.startsWith(`${TranslationNoticeToast.COOKIE_NAME}=`));
    }

    setDismissedCookie() {
      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 999);
      document.cookie = `${TranslationNoticeToast.COOKIE_NAME}=1; expires=${endOfDay.toUTCString()}; path=/; SameSite=Lax; Secure`;
    }

    show() {
      if (!this.toast) return;

      this.toast.classList.add('is-active');
      this.toast.classList.remove('scroll-trigger--offscreen');
    }

    dismiss() {
      if (this.isClosing || !this.toast) return;

      this.isClosing = true;
      this.setDismissedCookie();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        this.hideImmediately();
        return;
      }

      this.toast.classList.remove('animate--slide-in');
      this.toast.style.animation = 'none';
      void this.toast.offsetHeight;

      requestAnimationFrame(() => {
        this.toast.classList.add('is-closing');
        this.toast.style.animation = '';

        this.toast.addEventListener(
          'animationend',
          (event) => {
            if (event.animationName !== 'translationNoticeSlideOut') return;
            this.hideImmediately();
          },
          { once: true }
        );
      });
    }

    hideImmediately() {
      if (!this.toast) return;

      this.toast.style.animation = '';
      this.toast.classList.remove('is-active', 'is-closing', 'animate--slide-in');
      this.toast.classList.add('scroll-trigger--offscreen');
      this.isClosing = false;
    }
  }

  customElements.define('translation-notice-toast', TranslationNoticeToast);
}
